// extracted by mini-css-extract-plugin
export default {"priceRadioGroup":"EditForm_priceRadioGroup__eJTXH"};